//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showIntroBubble: true,
            showNext: false,
            puzzles: [
                {
                    image: 'bagger_4.png',
                    inDropArea: false,
                    x: 100,
                    y: 180,
                    width: 157,
                    height: 335,
                    dropAreas: [{
                        xMin: 837,
                        xMax: 994,
                        yMin: 203,
                        yMax: 538
                    }]
                },
                {
                    image: 'bagger_1.png',
                    inDropArea: false,
                    x: 650,
                    y: 20,
                    width: 201,
                    height: 289,
                    dropAreas: [{
                        xMin: 704,
                        xMax: 905,
                        yMin: 206,
                        yMax: 495
                    }]
                },
                {
                    image: 'bagger_2.png',
                    inDropArea: false,
                    x: 1000,
                    y: 150,
                    width: 149,
                    height: 187,
                    dropAreas: [{
                        xMin: 388,
                        xMax: 537,
                        yMin: 313,
                        yMax: 500
                    }]
                },
                {
                    image: 'bagger_3.png',
                    inDropArea: false,
                    x: 200,
                    y: 150,
                    width: 134,
                    height: 134,
                    dropAreas: [{
                        xMin: 354,
                        xMax: 488,
                        yMin: 534,
                        yMax: 668
                    }, {
                        xMin: 605,
                        xMax: 739,
                        yMin: 534,
                        yMax: 668
                    }]
                },
                {
                    image: 'bagger_3.png',
                    inDropArea: false,
                    x: 50,
                    y: 550,
                    width: 134,
                    height: 134,
                    dropAreas: [{
                        xMin: 354,
                        xMax: 488,
                        yMin: 534,
                        yMax: 668
                    }, {
                        xMin: 605,
                        xMax: 739,
                        yMin: 534,
                        yMax: 668
                    }]
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.inDropArea).length;

            return this.$game.getDragDropResult(numCorrect, this.puzzles.length - numCorrect);
        }
    },

    methods: {
        dragend (puzzle, { x, y }) {
            this.showIntroBubble = false;

            puzzle.x = x;
            puzzle.y = y;
            let dropAreaIndex = puzzle.dropAreas.findIndex(dropArea => puzzle.x >= dropArea.xMin - puzzle.width / 2 &&
                puzzle.x <= dropArea.xMax - puzzle.width / 2 &&
                puzzle.y >= dropArea.yMin - puzzle.height / 2 &&
                puzzle.y <= dropArea.yMax - puzzle.height / 2);

            if (dropAreaIndex !== -1) {
                puzzle.inDropArea = true;

                this.$nextTick(() => {
                    puzzle.x = puzzle.dropAreas[dropAreaIndex].xMin;
                    puzzle.y = puzzle.dropAreas[dropAreaIndex].yMin;
                });
            } else {
                puzzle.inDropArea = false;
            }
        }
    }
};
